/* eslint-disable react-hooks/rules-of-hooks */
import {usePost} from '@/lib/reactQuery.ts';
import {
  AcceptBookingRequest,
  CheckinLoginParams,
  SearchCustomerParams,
} from './types';
import {AxiosResponse} from 'axios';

// 접수 패드용 로그인 API
export const login = () => {
  return usePost<AxiosResponse<string>, CheckinLoginParams>(`login`);
};

// 고객 검색 API
export const searchCustomer = (params: SearchCustomerParams) => {
  return usePost<AxiosResponse<any>, unknown>(`customer`, params);
};

// 예약 접수 API
export const checkinBooking = () => {
  return usePost<AxiosResponse<boolean>, AcceptBookingRequest>('booking');
};

// 고객 검색 및 예약 조회 API
export const checkCustomerAndBooking = (params: SearchCustomerParams) => {
  return usePost<AxiosResponse<any>, unknown>(
    `check-customer-and-booking`,
    params,
  );
};
